import http from "./httpService";
import { authApi } from "./config.json";
var base64 = require("base-64");
function login(username, password) {
  return http.post(authApi + "checkUserByDepartment.php", {
    username,
    password,
    department: "report",
  });
}
function logout(e) {
  localStorage.removeItem("user_report");
  localStorage.removeItem("id_customer_report");
  localStorage.removeItem("token_report");
  e.props.history.replace("/login");
}
function getCurrentIdCustomer() {
  return localStorage.getItem("id_customer_report");
}
function getCurrentUser() {
  return localStorage.getItem("user_report");
}
function getAksesToken() {
  return localStorage.getItem("token_report");
}
function getAkses(modul,action){
  const akses = localStorage.getItem("akses_report");
  if(akses !== null && akses!==undefined){
    const arrAkses = JSON.parse(base64.decode(akses));
    if (arrAkses===null) return 0 ;
    if (arrAkses[modul]===null || arrAkses[modul]===undefined) return 0;
    if (arrAkses[modul][action]===null) return 0;
    return arrAkses[modul][action];
  }
  return 0;
}


export default {
  login,
  getCurrentUser,
  getCurrentIdCustomer,
  getAksesToken,
  getAkses,
  logout,
};



// WEBPACK FOOTER //
// ./src/services/authService.js